import { selectRouterPathname } from '@noths/polaris-client-next-redux';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { replace } from 'connected-next-router';
import qs from 'querystring';

import { PRODUCT_CONTAINER_WRAPPER } from '../../../constants/elementIds';
import { ReduxApplicationState } from '../../combinedReducer';
import { selectRequestOptionsAsQueryObject } from '../selectors';
import { requestProducts, requestProductsIsRejected } from './requestProducts';

export enum UpdateFiltersActionType {
  SORT = 'SORT',
  FILTER = 'FILTER',
}

export const updateFilters = createAsyncThunk(
  'products/updateFilters',
  async (filterType: UpdateFiltersActionType, { getState, dispatch, rejectWithValue }) => {
    const state = getState() as ReduxApplicationState;
    const {
      router: {
        location: { pathname },
      },
      filter: {
        collections: { lastUpdatedFilter },
      },
    } = state;

    const queryObject = selectRequestOptionsAsQueryObject(state);

    const query = qs.stringify(queryObject);

    dispatch(
      replace(
        {
          pathname: selectRouterPathname(state),
          query,
        },
        query ? `${pathname}?${query}` : pathname,
        { shallow: true, scroll: false },
      ),
    );

    if (lastUpdatedFilter) {
      const { filterUid, filterOptionValue, type } = lastUpdatedFilter;

      queryObject.updatedFilter = filterUid;
      queryObject.updatedFilterOption = filterOptionValue;
      queryObject.updatedFilterAction = type === 'SELECT' ? 'selected' : 'deselected';
    }

    const action = await dispatch(
      requestProducts({
        query: {
          ...queryObject,
          path: pathname,
        },
      }),
    );

    if (requestProductsIsRejected(action)) {
      return rejectWithValue('There was a problem loading products');
    }

    const productContainerOffsetTop = document.getElementById(PRODUCT_CONTAINER_WRAPPER)?.offsetTop;
    window.scrollTo({ top: productContainerOffsetTop, behavior: 'auto' });

    return filterType;
  },
);
